import { Component, Input, OnInit, ViewChild } from "@angular/core";

import {
  ApexChart,
  ApexFill,
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexStroke,
  ChartComponent
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  plotOptions: ApexPlotOptions;
  colors: string[];
  fill: ApexFill;
  stroke: ApexStroke;

};

@Component({
  selector: 'app-radialbar-chart',
  templateUrl: './radialbar.component.html',
  styleUrls: ['./radialbar.component.scss']
})

export class RadialbarChartComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  @Input() lable: [];
  @Input() series: [];

  constructor() { }

  ngOnInit() {
    this.chartOptions = {
      series: this.series,
      chart: {
        height: 250,
        type: "radialBar"
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: '50%',  // Adjust the inner circle size

          },
          track: {
            strokeWidth: '80%',  // Adjust thickness of the track
          },
          dataLabels: {
            name: {
              fontSize: '16px',
              offsetY: -3,
            },
            value: {
              fontSize: '15px',
              color: '#333',  // Value text color
              offsetY: 3,
            }
          },

        }
      },
      stroke: {
        lineCap: "round",
      },
      labels: this.lable,
      colors: ['#EBB901'],
    };
  }
}